"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_skype_option_1 = require("owa-skype-option");
var skypeSubCategory = {
    key: 'skype',
    titleStringKey: 'optionSubcategory_skype',
    options: [owa_skype_option_1.SkypeNotificationOption],
};
exports.default = skypeSubCategory;
//# sourceMappingURL=skypeSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-options-general/lib/config/skypeSubCategory.js
// module id = 4976
// module chunks = 2